// Portfolio Data for Ayushi Chhabra - Content Producer

export const personalInfo = {
  name: "Ayushi Chhabra",
  title: "Senior Content Producer & On-Camera Host",
  subtitle: "Founder, Ayuka Group",
  tagline: "Crafting impactful brand narratives through culturally resonant storytelling",
  location: "Johannesburg, South Africa",
  email: "chhabra.ayushi@gmail.com",
  linkedin: "https://www.linkedin.com/in/ayushi-chhabra",
  bio: "Senior content producer and on-camera host with 10+ years of experience creating impactful brand narratives for clients like Adobe, Lexus, AARP, LA County, and Bhindi Jewelers. Expert in end-to-end content creation, from research and scripting to directing and delivery, for TV segments, commercials, docuseries, and digital campaigns. Blends cultural insight and creative strategy to craft stories that drive engagement, strengthen brand identity, and reach millions across digital and broadcast platforms.",
  image: "/images/Hero-Pic_option_2.png",
  ayukaLogo: "/images/AYUKA_logo.svg",
  ayukaLogoPng: "/images/AYUKA_logo.png"
};

export const stats = [
  { label: "Revenue Generated", value: "$450K+", description: "Through media grants" },
  { label: "Broadcast Reach", value: "25M+", description: "Viewers nationwide" },
  { label: "Digital Impressions", value: "1M+", description: "Across campaigns" },
  { label: "Years Experience", value: "10+", description: "In content production" }
];

export const projects = [
  {
    id: 1,
    title: "South Asian Elderly Caregiving Docuseries",
    client: "AARP",
    category: "broadcast",
    year: "2022-2023",
    role: "Lead Producer",
    description: "Lead Producer of a six-part mini-docuseries for AARP on Elderly Caregiving in the South Asian community. Aired on Showbiz India TV, reaching 25 million U.S. households via KXLA19, KTSF26, WRJK22.3, KLEG44.3 & multiple Xfinity channels, and distributed globally through the ZEE TV international network with a reach of over 670 million viewers, in 169 countries.",
    tags: ["Docuseries", "TV Broadcast", "Global Distribution"],
    bgColor: "#2D5F5D",
    textColor: "#FAF8F5",
    reach: [
      { label: "Broadcast", value: "25M+" },
      { label: "Youtube", value: "63K" },
      { label: "Episodes", value: "6" }
    ],
    episodes: [
      { title: "Elderly Fraud & Fraud Prevention", videoUrl: "https://www.youtube.com/embed/65VBbgB5sQU", views: "16K" },
      { title: "Elderly Social Isolation", videoUrl: "https://www.youtube.com/embed/vIRV43dzbaU", views: "21K" },
      { title: "Elderly Financial Planning", videoUrl: "https://www.youtube.com/embed/ENx4bIQkAzw", views: "12K" },
      { title: "Elderly Health & Wellness", videoUrl: "https://www.youtube.com/embed/xeNwlB4yQJc", views: "14K" }
    ],
    videoUrl: "https://www.youtube.com/embed/vIRV43dzbaU",
    thumbnail: "https://img.youtube.com/vi/vIRV43dzbaU/maxresdefault.jpg"
  },
  {
    id: 2,
    title: "Adobe Changemaker of the Year Award",
    client: "LA County Dept of Mental Health",
    category: "social-impact",
    year: "2023",
    role: "Lead Producer",
    description: "In 2023, Showbiz India TV's production team, led by Ayushi Chhabra and Reshma Dordi, was honored with the Adobe Changemaker of the Year Award for their impactful use of Adobe tools to create content that amplifies mental health awareness within the South Asian community.",
    tags: ["Award", "Mental Health", "Adobe Recognition"],
    bgColor: "#C9A961",
    textColor: "#1a1520",
    reach: [
      { label: "Award", value: "Adobe Changemaker 2023" },
      { label: "Mental Health", value: "Social Impact" }
    ],
    videoUrl: "https://www.youtube.com/embed/X2mJCVbOysk",
    thumbnail: "https://img.youtube.com/vi/X2mJCVbOysk/maxresdefault.jpg"
  },
  {
    id: 3,
    title: "Be A Bhindi Girl Campaign",
    client: "Bhindi Jewelers",
    category: "broadcast",
    year: "2023",
    role: "Senior Producer",
    description: "A multichannel campaign celebrating women and their unbreakable spirit, featuring diverse representation across TV broadcast, YouTube, social media, and print editorial formats.",
    tags: ["TV Commercial", "Social Media", "Broadcast"],
    bgColor: "#8B2635",
    textColor: "#FAF8F5",
    reach: [
      { label: "Broadcast", value: "18M" },
      { label: "Youtube", value: "713K" },
      { label: "Instagram", value: "12K" }
    ],
    videoUrl: "https://www.youtube.com/embed/276PnR4TwCY",
    thumbnail: "https://img.youtube.com/vi/276PnR4TwCY/maxresdefault.jpg"
  },
  {
    id: 4,
    title: "Lexus x Holi Campaign",
    client: "IW Group x Lexus",
    category: "broadcast",
    year: "2023",
    role: "Campaign Producer",
    description: "Collaborated with IW Group to curate a Holi-themed campaign tailored for South Asian audiences. Developed and produced a culturally resonant segment that integrated Lexus branding with the vibrant spirit of Holi, incorporating elements of Bollywood, music, and tradition. Aired on Showbiz India TV's national broadcast network in the U.S, and on SBI's youtube & social media channels.",
    tags: ["Branded Content", "TV Broadcast", "Cultural Campaign"],
    bgColor: "#B8628A",
    textColor: "#FAF8F5",
    reach: [
      { label: "Broadcast", value: "25M+" },
      { label: "Youtube", value: "11K" },
      { label: "Instagram", value: "705K" }
    ],
    videoUrl: "https://www.youtube.com/embed/0ItsU41MWFU",
    thumbnail: "https://img.youtube.com/vi/0ItsU41MWFU/maxresdefault.jpg"
  },
  {
    id: 5,
    title: "Mother's Day Catalog",
    client: "Bhindi Jewelers",
    category: "print",
    year: "2023",
    role: "Director & Co-Producer",
    description: "Directed and co-produced this Bhindi Jewelers print catalog for Mother's Day 2023. This multi-generational concept was developed by me, and I led the casting and wardrobe, worked with clients, directed all shots, and guided models with poses and jewelry.",
    tags: ["Print Editorial", "Catalog", "Direction"],
    bgColor: "#8B7355",
    textColor: "#FAF8F5",
    reach: null,
    videoUrl: null,
    thumbnail: "/images/mothers-day-main.jpg",
    images: [
      "/images/mothers-day-1.jpg",
      "/images/mothers-day-2.jpg",
      "/images/mothers-day-3.jpg",
      "/images/mothers-day-4.jpg",
      "/images/mothers-day-5.jpg",
      "/images/mothers-day-6.jpg",
      "/images/mothers-day-7.jpg",
      "/images/mothers-day-8.jpg",
      "/images/mothers-day-9.jpg",
      "/images/mothers-day-10.jpg",
      "/images/mothers-day-11.jpg",
      "/images/mothers-day-12.jpg",
      "/images/mothers-day-13.jpg",
      "/images/mothers-day-14.jpg"
    ]
  },
  {
    id: 6,
    title: "Diversity Print Campaign",
    client: "Bhindi Jewelers",
    category: "print",
    year: "2023",
    role: "Senior Producer | Director",
    description: "Print editorial component of the 'Be A Bhindi Girl' campaign celebrating diversity and empowerment. Led creative direction, casting, and production for this multicultural jewelry campaign featuring diverse models across print and social media formats.",
    tags: ["Print Editorial", "Diversity", "Empowerment"],
    bgColor: "#8B2635",
    textColor: "#FAF8F5",
    reach: null,
    videoUrl: null,
    thumbnail: "/images/bhindi-print-1.jpg",
    images: [
      "/images/bhindi-print-1.jpg",
      "/images/bhindi-print-2.jpg",
      "/images/bhindi-print-3.jpg",
      "/images/bhindi-print-4.jpg",
      "/images/bhindi-print-5.jpg",
      "/images/bhindi-print-6.jpg",
      "/images/bhindi-print-7.jpg",
      "/images/bhindi-print-8.jpg",
      "/images/bhindi-print-9.jpg",
      "/images/bhindi-print-10.jpg"
    ]
  },
  {
    id: 7,
    title: "Mental Health Awareness PSAs",
    client: "LA County Dept of Mental Health",
    category: "social-impact",
    year: "2021-2023",
    role: "Lead Producer | Grants Writer",
    description: "Over a two-year period, I led the end-to-end production of three PSAs for the LA County Department of Mental Health, aimed at engaging the South Asian community. I initiated and secured the project by writing a successful $100,000 grant proposal. I conceptualized the campaign, wrote scripts in both English and Hindi, and produced all three PSAs from initial concept to final delivery.",
    tags: ["PSA", "Bilingual", "Grant-Funded"],
    bgColor: "#C9A961",
    textColor: "#1a1520",
    reach: [
      { label: "Grant Secured", value: "$100K" },
      { label: "PSAs Produced", value: "3" },
      { label: "Languages", value: "2" }
    ],
    psaVideos: [
      { title: "Mental Health Has Many Faces", videoUrl: "https://www.youtube.com/embed/3hxM4OukbhM" },
      { title: "South Asian Youth Mental Health (English)", videoUrl: "https://www.youtube.com/embed/KuigmoMmGL4" },
      { title: "Special Message by Reshma Dordi (Hindi)", videoUrl: "https://www.youtube.com/embed/Y6Mwgi0ORho" }
    ],
    videoUrl: "https://www.youtube.com/embed/3hxM4OukbhM",
    thumbnail: "https://img.youtube.com/vi/3hxM4OukbhM/maxresdefault.jpg"
  },
  {
    id: 8,
    title: "Anti-Asian Hate Crimes Awareness PSAs",
    client: "California State Library (CALMHSA)",
    category: "social-impact",
    year: "2022-2023",
    role: "Lead Producer | Grants Writer",
    description: "In both 2022 and 2023, I successfully wrote and secured grant proposals from the California State Library, totaling over $200,000 in funding. We were awarded $100K each year to produce original content addressing anti-Asian hate, which aired on Showbiz India TV. I wrote all the scripts for these PSAs, which aimed to raise awareness and foster dialogue within the South Asian community.",
    tags: ["PSA", "Social Justice", "Grant-Funded"],
    bgColor: "#2D5F5D",
    textColor: "#FAF8F5",
    reach: [
      { label: "Grants Secured", value: "$200K" },
      { label: "Platform", value: "Broadcast & Digital" },
      { label: "Years", value: "2022-23" }
    ],
    psaVideos: [
      { title: "Los Angeles South Asian Community Experiences", videoUrl: "https://www.youtube.com/embed/v28XcLVwfLo" },
      { title: "Stop Asian Hate Now - PSA", videoUrl: "https://www.youtube.com/embed/rEfQL9tYkHA" },
      { title: "Interview with Payal Sawhney of SAAHAS", videoUrl: "https://www.youtube.com/embed/0q2VN7GGXpo" }
    ],
    videoUrl: "https://www.youtube.com/embed/v28XcLVwfLo",
    thumbnail: "https://img.youtube.com/vi/v28XcLVwfLo/maxresdefault.jpg"
  },
  {
    id: 9,
    title: "Reshma Beauty 'Namaste' Commercial",
    client: "Reshma Beauty",
    category: "broadcast",
    year: "2016-2018",
    role: "Lead Producer",
    description: "I conceptualized, scripted, and produced a commercial for natural skincare brand, Reshma Beauty, overseeing the project from start to finish. My responsibilities included developing the creative concept, writing the script, casting talent, securing crew, equipment, and locations, and managing the post-production process through to final delivery. Aired on Showbiz India TV's national network and on Reshma Beauty's digital platforms.",
    tags: ["TV Commercial", "Product Launch", "Broadcast"],
    bgColor: "#B8628A",
    textColor: "#FAF8F5",
    reach: [
      { label: "Broadcast", value: "25M+" },
      { label: "Youtube", value: "228K" }
    ],
    videoUrl: "https://www.youtube.com/embed/frnaTSAylBM",
    thumbnail: "https://img.youtube.com/vi/frnaTSAylBM/maxresdefault.jpg"
  }
];

export const skills = {
  leadership: [
    "Budget Oversight ($200K+)",
    "Team Leadership (25+ professionals)",
    "Client Acquisition & Retention",
    "AI-Enhanced Client Pitches",
    "Production Coordination",
    "Client Acquisition & Retention",
    "Stakeholder Communication",
    "Cross-Platform Execution"
  ],
  production: [
    "Generative AI Content Development",
    "Data-Driven Storytelling",
    "End-to-End Content Production",
    "Client Relationship Management",
    "Project & Timeline Management",
    "Quality Assurance"
  ],
  creative: [
    "High-Velocity Ideation",
    "Creative Brief Development",
    "Cultural Trend Analysis",
    "Creative Direction",
    "Insight-Driven Creative Strategy",
    "Editorial Writing",
    "On-Camera Hosting & Interviewing"
  ],
  technical: [
    "Generative AI: ChatGPT, Claude, Gemini",
    "AI Video Tools: Runway",
    "AI Image Support: Canva AI, Adobe Firefly",
    "Workflow Tools: Notion AI",
    "Content & Social Tools: Meta Suite, Hootsuite",
    "Analytics: Google Analytics"
  ]
};

export const awards = [
  {
    title: "Adobe Changemaker of the Year",
    year: "2023",
    description: "Honored for impactful mental health awareness campaign using Adobe tools",
    icon: "award"
  },
  {
    title: "$450K in Media Grants Secured",
    year: "2021-2023",
    description: "LA County Dept of Mental Health & California State Library",
    icon: "trophy"
  },
  {
    title: "Social Media Growth Excellence",
    year: "2022-2024",
    description: "Grew Bhindi Jewelers following by 50%, reaching 120K+ accounts monthly",
    icon: "trending-up"
  }
];

export const testimonials = [];
